export const DAILY = 0;
export const WEEKLY = 1;
export const MONTHLY = 2;
